import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import jQuery from "utilities/vendor/jquery/3.7.1/js/jquery";
import $ from "utilities/vendor/jquery/3.7.1/js/jquery";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.10/js/sparta-ui-layers-utility";
import Module from "utilities/global/sparta-module-utility/6.3.1/js/sparta-module-utility";
import currentWidgetDetails from "utilities/platform/widget-details";














export default class AhModalUtility {





    constructor(options = {}) {
        this.options = options;

        this.spartaUILayersUtility = spartaUILayersUtility;

        this.CACHED = {};
        this.CACHED._WidgetContainerRoot = {};


        this.$ = $;
        this._ = _;

        this.ahCawCommons = ahCawCommons;
        this.bindThisContext();
    }

    bindThisContext() {
        this.ahCawCommons.bindThisContext(
            [
                "openRequestModalLayer",
                "closeModal"
            ],
            this,
            ""
        );
        return this;
    }

    openRequestModalLayer(modalRequestOptions, $moduleContext ) {
        const self = this;



        if (self.isModalAlreadyOpened(modalRequestOptions.$moduleContext)) {
            self.ahCawCommons._show(`#${modalRequestOptions.modalContentWrapperID}`, $moduleContext);
        } else {
            self.CACHED._WidgetContainerRoot[modalRequestOptions.widgetContainerRoot] =
                modalRequestOptions.$moduleContext.find(modalRequestOptions.widgetContainerRoot);
            const $modalContentWrapper = self.createModalContentWrapper(modalRequestOptions.$moduleContext,
                modalRequestOptions.widgetContainerRoot, modalRequestOptions.modalContentWrapperID);

            let $clonedWidgetContainer = self.CACHED._WidgetContainerRoot[modalRequestOptions.widgetContainerRoot]
                .find("> ." + modalRequestOptions.widgetContainerTemplate)
                .clone()
                .removeClass("hide");
            $clonedWidgetContainer.prop("id", modalRequestOptions.widgetContainer);

            $modalContentWrapper.append($clonedWidgetContainer);

            const modalOptions = {
                type: "modal",
                closeOnEscape: modalRequestOptions.closeOnEscape ? true : false,
                optionalClasses: this.getModalWindowClass(modalRequestOptions.$moduleContext),
                contentId: modalRequestOptions.modalWindowContentID,
                width: modalRequestOptions.width || "500",
                closeButton: true
            };







            $modalContentWrapper.data("options", modalOptions);








            self.spartaUILayersUtility.openLayer($modalContentWrapper);
        }
    }



    createModalContentWrapper($moduleContext, widgetContainerRoot, modalContentWrapperID) {
        const self = this;
        const $ = self.$;

        let $modalContentWrapper = $moduleContext.find(`#${modalContentWrapperID}`);
        if ($modalContentWrapper.length === 0) {
            self.CACHED._WidgetContainerRoot[widgetContainerRoot].append(
                $("<div/>")
                    .attr("id", modalContentWrapperID)
                    .addClass("hide")
            );
            $modalContentWrapper = $moduleContext.find(`#${modalContentWrapperID}`);
        }
        return $modalContentWrapper;
    }

    isModalAlreadyOpened($moduleContext) {
        let modalWindowClassName = this.getModalWindowClass($moduleContext);
        let $moduleModalWindowContext = $(`.${modalWindowClassName}`);
        if($moduleModalWindowContext.length > 0) {
            return true;
        }
        return false;
    }

    getModalWindowClass($moduleContext) {
        let modalWindowClassName = `${$moduleContext.attr("class").split(" ")[0]}-modalwindow`;
        return modalWindowClassName;
    }

    closeModal() {
        const self = this;
        self.spartaUILayersUtility.closeLayer();
    }
}
